<template>
  <div>
    <div class="advance-search-modal">
      <div class="lv3-title-text">Advance Search</div>
      <div class="lv3-edit-form">
        <div class="half-input-wrapper">
          <div class="hiw-label">Nama Vendor</div>
          <div class="hiw-multiple">
            <input type="text" class="hiw-text" v-model="vendorName" placeholder="Nama Vendor / Kode KBLI" />
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Kegiatan Usaha Utama</div>
          <div class="hiw-single">
            <button class="btn-standart" @click="showKbliEdit()">
              Tambah
              {{ choosedKbli.length > 0 ? `( ${choosedKbli.length} )` : '' }}
            </button>
            <div class="text-wrapper-expand" v-if="choosedKbli.length > 0" @click="kbliShowBtn">
              <div v-if="!kbliShow">
                Click for more...
              </div>
              <div v-else>
                <div class="horizontal">
                  <div class="column10">Kode</div>
                  <div class="column30 mr10">Keterangan</div>
                </div>
                <div class="horizontal" v-for="(item, index) in choosedKbli" :key="index">
                  <div class="column10">{{ item.kode }}</div>
                  <div class="column90 col-nohover mr10">{{ item.desc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Negara</div>
          <div class="hiw-multiple">
            <v-select class="style-chooser" placeholder="Pilih Negara" label="negara" :options="countries"
              v-model="choosedCountry" />
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Provinsi</div>
          <div class="hiw-multiple">
            <v-select class="style-chooser" placeholder="Pilih Provinsi" label="desc" :options="provinces"
              v-model="choosedProvince" />
          </div>
        </div>
        <div class="half-input-wrapper" v-if="choosedProvince">
          <div class="hiw-label">Kota</div>
          <v-select class="style-chooser" placeholder="Pilih Kota" label="desc" :options="cities"
            v-model="choosedCity" />
        </div>
        <div class="half-input-wrapper" v-if="choosedCity">
          <div class="hiw-label">Kecamatan</div>
          <v-select class="style-chooser" placeholder="Pilih Kecamatan" label="desc" :options="districs"
            v-model="choosedDistric" />
        </div>
        <div class="half-input-wrapper" v-if="choosedDistric">
          <div class="hiw-label">Kelurahan</div>
          <v-select class="style-chooser" placeholder="Pilih Kelurahan" label="desc" :options="villages"
            v-model="choosedVillage" />
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">SIO</div>
          <div class="hiw-multiple">
            <label class="hiw-2-row"><input type="radio" value="1" v-model="chooseSio"
                style="margin-right: 10px" />Active</label>
            <label class="hiw-2-row"><input type="radio" value="0" v-model="chooseSio" style="margin-right: 10px" />Not
              Active</label>
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Pertambangan</div>
          <div class="hiw-multiple">
            <label class="hiw-2-row"><input type="radio" value="1" v-model="chooseMine"
                style="margin-right: 10px" />Inti</label>
            <label class="hiw-2-row"><input type="radio" value="0" v-model="chooseMine" style="margin-right: 10px" />Non
              Inti</label>
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Praqualifikasi</div>
          <div class="hiw-multiple">
            <label class="hiw-2-row"><input type="checkbox" value="k3l" v-model="choosePraqualifikasiK3l"
                style="margin-right: 10px" />K3L</label>
            <label class="hiw-2-row"><input type="checkbox" value="kplh" v-model="choosePraqualifikasiKplh"
                style="margin-right: 10px" />KPLH</label>
          </div>
        </div>

        <div class="half-input-wrapper" v-if="k3lCategories && choosePraqualifikasiK3l">
          <div class="hiw-label">Nilai K3L</div>
          <div class="hiw-multiple">
            <label class="hiw-4s-row" v-for="(list, index) in k3lCategories" :key="index">
              <input type="checkbox" :value="list.id" v-model="chooseK3lScore" style="margin-right: 10px" />
              {{ list.desc }}
            </label>
          </div>
        </div>
        <div class="half-input-wrapper" v-if="kplhCategories && choosePraqualifikasiKplh">
          <div class="hiw-label">Nilai KPLH</div>
          <div class="hiw-multiple">
            <label class="hiw-4s-row" v-for="(list, index) in kplhCategories" :key="index">
              <input type="checkbox" :value="list.id" v-model="chooseKplhScore" style="margin-right: 10px" />
              {{ list.desc }}
            </label>
          </div>
        </div>

        <div class="half-input-wrapper">
          <div class="hiw-label">Klasifikasi IUJP</div>
          <div class="hiw-single">
            <button class="btn-standart" @click="showIujpEdit()">
              Tambah
              {{ choosedIujp.length > 0 ? `( ${choosedIujp.length} )` : '' }}
            </button>
            <div class="text-wrapper-expand" v-if="choosedIujp.length > 0" @click="iujpShowBtn">
              <div v-if="!iujpShow">
                Click for more...
              </div>
              <div v-else>
                <div class="horizontal">
                  <div class="column10">Jenis</div>
                  <div class="column30 mr10">Bidang</div>
                  <div class="column50 mr10">Sub Bidang</div>
                </div>
                <div class="horizontal" v-for="(item, index) in choosedIujp" :key="index">
                  <div class="column10">{{ item.jenis }}</div>
                  <div class="column30 mr10">{{ item.bidang }}</div>
                  <div class="column50 mr10">{{ item.sub_bidang }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Klasifikasi SBUJK</div>
          <div class="hiw-single">
            <button class="btn-standart" @click="showSbujkEdit()">
              Tambah
              {{ choosedSbujk.length > 0 ? `( ${choosedSbujk.length} )` : '' }}
            </button>
            <div class="text-wrapper-expand" v-if="choosedSbujk.length > 0" @click="sbujkShowBtn">
              <div v-if="!sbujkShow">
                Click for more...
              </div>
              <div v-else>
                <div class="horizontal">
                  <div class="column10">Kode</div>
                  <div class="column20 mr10">Klasifikasi</div>
                  <div class="column40 mr10">Sub Klasifikasi</div>
                  <div class="column20">Kualifikasi</div>
                </div>
                <div class="horizontal" v-for="(item, index) in choosedSbujk" :key="index">
                  <div class="column10">{{ item.kode }}</div>
                  <div class="column20 mr10">{{ item.klasifikasi }}</div>
                  <div class="column40 mr10">{{ item.sub_klasifikasi }}</div>
                  <div class="column20">{{ item.kualifikasi }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Klasifikasi IUJPTL</div>
          <div class="hiw-single">
            <button class="btn-standart" @click="showIujptlEdit()">
              Tambah
              {{
                choosedIujptl.length > 0 ? `( ${choosedIujptl.length} )` : ''
              }}
            </button>
            <div class="text-wrapper-expand" v-if="choosedIujptl.length > 0" @click="iujptlShowBtn">
              <div v-if="!iujptlShow">
                Click for more...
              </div>
              <div v-else>
                <div class="horizontal">
                  <div class="column10">Jenis Usaha</div>
                  <div class="column20 mr10">Bidang</div>
                  <div class="column40 mr10">Sub Bidang</div>
                  <div class="column20">Kualifikasi</div>
                </div>
                <div class="horizontal" v-for="(item, index) in choosedIujptl" :key="index">
                  <div class="column10 all-column">{{ item.jenis_usaha }}</div>
                  <div class="column20 mr10">{{ item.bidang }}</div>
                  <div class="column40 mr10">{{ item.sub_bidang }}</div>
                  <div class="column20">{{ item.kualifikasi }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Klasifikasi INU BBM</div>
          <div class="hiw-single">
            <button class="btn-standart" @click="showInuBbmEdit()">
              Tambah
              {{
                choosedInuBbm.length > 0 ? `( ${choosedInuBbm.length} )` : ''
              }}
            </button>
            <div class="text-wrapper-expand" v-if="choosedInuBbm.length > 0" @click="inubbmShowBtn">
              <div v-if="!inubbmShow">
                Click for more...
              </div>
              <div v-else>
                <div class="horizontal">
                  <div class="column40 mr10">Bidang</div>
                </div>
                <div class="horizontal" v-for="(item, index) in choosedInuBbm" :key="index">
                  <div class="column90 all-column">{{ item.desc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Klasifikasi SIUPAL</div>
          <div class="hiw-single">
            <button class="btn-standart" @click="showSiupalEdit()">
              Tambah
              {{
                choosedSiupal.length > 0 ? `( ${choosedSiupal.length} )` : ''
              }}
            </button>
            <div class="text-wrapper-expand" v-if="choosedSiupal.length > 0" @click="siupalShowBtn">
              <div v-if="!siupalShow">
                Click for more...
              </div>
              <div v-else>
                <div class="horizontal">
                  <div class="column40 mr10">Bidang</div>
                </div>
                <div class="horizontal" v-for="(item, index) in choosedSiupal" :key="index">
                  <div class="column90 all-column">{{ item.desc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="half-input-wrapper">
          <div class="hiw-label">Status</div>
          <div class="hiw-multiple">
            <label class="hiw-4s-row"><input type="radio" value="1" v-model="chooseStatus"
                style="margin-right: 10px" />Active</label>
            <label class="hiw-4s-row"><input type="radio" value="2" v-model="chooseStatus"
                style="margin-right: 10px" />Block</label>
            <label class="hiw-4s-row"><input type="radio" value="3" v-model="chooseStatus"
                style="margin-right: 10px" />Active Only</label>
            <label class="hiw-4s-row"><input type="radio" value="4" v-model="chooseStatus"
                style="margin-right: 10px" />Block Only</label>
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Periode</div>
          <div class="hiw-multiple">
            <label class="hiw-4s-row">
              <input type="radio" value="3" v-model="choosePeriode" style="margin-right: 10px" />
              3 Bulan
            </label>
            <label class="hiw-4s-row"><input type="radio" value="6" v-model="choosePeriode"
                style="margin-right: 10px" />6 Bulan</label>
            <label class="hiw-4s-row"><input type="radio" value="12" v-model="choosePeriode"
                style="margin-right: 10px" />12 Bulan</label>
            <label class="hiw-4s-row"><input type="radio" value="24" v-model="choosePeriode"
                style="margin-right: 10px" />24 Bulan</label>
          </div>
        </div>

        <div class="half-input-wrapper">
          <div class="hiw-label">Nilai Kinerja PO</div>
          <div class="hiw-multiple">
            <input type="number" class="hiw-2-row" placeholder="input 0 - 5" min="0.0" max="5.0"
              v-model="poScoreStart" />
            <input type="number" class="hiw-2-row" placeholder="input 0 - 5" min="0.0" max="5.0" v-model="poScoreEnd" />
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Nilai Kinerja Kontrak</div>
          <div class="hiw-multiple">
            <input type="number" class="hiw-2-row" placeholder="input 0 - 100" min="0.0" max="100.0"
              v-model="spmScoreStart" />
            <input type="number" class="hiw-2-row" placeholder="input 0 - 100" min="0.0" max="100.0"
              v-model="spmScoreEnd" />
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="resetFilter()">RESET</div>
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="runSearch()">CONFIRM</div>
        </div>
      </div>
    </div>
    <AddKbli v-if="$store.state.addEdit.addKbli" />
    <AddIujp v-if="$store.state.addEdit.addIujp" />
    <AddIujptl v-if="$store.state.addEdit.addIujptl" />
    <AddSbujk v-if="$store.state.addEdit.addSbujk" />
    <AddInuBbm v-if="$store.state.addEdit.addInuBbm" />
    <AddSiupal v-if="$store.state.addEdit.addSiupal" />
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
import moment from 'moment'
export default {
  components: {
    AddKbli: () => import('@/components/modal/AddKbliSearch.vue'),
    AddIujp: () => import('@/components/modal/AddIujpSearch.vue'),
    AddIujptl: () => import('@/components/modal/AddIujptlSearch.vue'),
    AddSbujk: () => import('@/components/modal/AddSbujkSearch.vue'),
    AddInuBbm: () => import('@/components/modal/AddInuBbmSearch.vue'),
    AddSiupal: () => import('@/components/modal/AddSiupalSearch.vue'),
  },
  data() {
    return {
      poScoreStart: 0,
      poScoreEnd: 0,
      spmScoreStart: 0,
      spmScoreEnd: 0,
      k3lStartDate: null,
      k3lEndDate: null,
      kplhStartDate: null,
      kplhEndDate: null,
      sioStartDate: null,
      sioEndDate: null,
      countries: [],
      choosedCountry: null,
      provinces: [],
      choosedProvince: null,
      cities: [],
      choosedCity: null,
      districs: [],
      choosedDistric: null,
      villages: [],
      choosedVillage: null,
      kbliList: [],
      k3lCategories: null,
      kplhCategories: null,
      periode: '',

      kbliShow: false,
      iujpShow: false,
      iujptlShow: false,
      sbujkShow: false,
      inubbmShow: false,
      siupalShow: false,
    }
  },
  created() {
    this.getCountry()
    this.getProvince()
    this.getKbli()
    this.getCriteria()
  },
  watch: {
    choosedIujp(value) {
      if (value.length > 0) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseMine',
          value: 1,
        })
      } else {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseMine',
          value: null,
        })
      }
    },
    choosedProvince: function (newValue, oldValue) {
      this.choosedVillage = null
      this.choosedDistric = null
      this.choosedCity = null
      this.getCity()
    },
    choosedCity: function (newChoosedCity, oldChoosedCity) {
      if (newChoosedCity !== oldChoosedCity && newChoosedCity !== null) {
        this.choosedVillage = null
        this.choosedDistric = null
        this.getDistric()
      }
    },
    choosedDistric: function (newChoosedDistric, oldChoosedDistric) {
      if (
        newChoosedDistric !== oldChoosedDistric &&
        newChoosedDistric !== null
      ) {
        this.choosedVillage = null
        this.getVillage()
      }
    },
  },
  computed: {
    vendorName: {
      get: function () {
        return this.$store.state.searchStore.vendorName
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'vendorName',
          value: newValue,
        })
      },
    },
    choosedKbli: {
      get: function () {
        return this.$store.state.searchStore.choosedKbli
      },
    },
    choosedIujp: {
      get: function () {
        return this.$store.state.searchStore.choosedIujp
      },
    },
    choosedIujptl: {
      get: function () {
        return this.$store.state.searchStore.choosedIujptl
      },
    },
    choosedSbujk: {
      get: function () {
        return this.$store.state.searchStore.choosedSbujk
      },
    },
    choosedInuBbm: {
      get: function () {
        return this.$store.state.searchStore.choosedInuBbm
      },
    },
    choosedSiupal: {
      get: function () {
        return this.$store.state.searchStore.choosedSiupal
      },
    },
    chooseSio: {
      get: function () {
        return this.$store.state.searchStore.chooseSio
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseSio',
          value: newValue,
        })
      },
    },
    chooseMine: {
      get: function () {
        return this.$store.state.searchStore.chooseMine
      },
      set: async function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseMine',
          value: newValue,
        })

        if (newValue == 0) {
          this.$store.commit('searchStore/SET_SEARCH_VALUE', {
            name: 'choosedIujp',
            value: [],
          })
        }


      },
    },
    choosePeriode: {
      get: function () {
        let periode = this.$store.state.searchStore.choosePeriode
        let newValue = periode
        const end = moment().format('YYYY-MM-DD')
        const start = this.monthFromNow(newValue)

        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePeriodePO',
          value: newValue,
        })

        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePeriodeEvent',
          value: newValue,
        })

        // START DATE
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customDetailPoStart',
          value: start,
        })
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customKinerjaPoStart',
          value: start,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'kinerjaPoStartDate',
          value: start,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poStartDate',
          value: start,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'eventStartDate',
          value: start,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'spmStartDate',
          value: start,
        })

        // END DATE
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customDetailPoEnd',
          value: end,
        })
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customKinerjaPoEnd',
          value: end,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'kinerjaPoEndDate',
          value: end,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poEndDate',
          value: end,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'eventEndDate',
          value: end,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'spmEndDate',
          value: end,
        })

        return periode
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePeriode',
          value: newValue,
        })
      },
    },
    chooseStatus: {
      get: function () {
        return this.$store.state.searchStore.chooseStatus
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseStatus',
          value: newValue,
        })
      },
    },
    chooseK3lScore: {
      get: function () {
        return this.$store.state.searchStore.chooseK3lScore
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseK3lScore',
          value: newValue,
        })
      },
    },
    chooseKplhScore: {
      get: function () {
        return this.$store.state.searchStore.chooseKplhScore
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseKplhScore',
          value: newValue,
        })
      },
    },
    poStartDate: {
      get: function () {
        return this.$store.state.searchStore.poStartDate
      },
      set: function (newValue) {
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customDetailPoStart',
          value: newValue,
        })
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customKinerjaPoStart',
          value: newValue,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'kinerjaPoStartDate',
          value: newValue,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poStartDate',
          value: newValue,
        })
      },
    },
    poEndDate: {
      get: function () {
        return this.$store.state.searchStore.poEndDate
      },
      set: function (newValue) {
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customDetailPoEnd',
          value: newValue,
        })
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customKinerjaPoEnd',
          value: newValue,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'kinerjaPoEndDate',
          value: newValue,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poEndDate',
          value: newValue,
        })
      },
    },
    eventStartDate: {
      get: function () {
        return this.$store.state.searchStore.eventStartDate
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'eventStartDate',
          value: newValue,
        })
      },
    },
    eventEndDate: {
      get: function () {
        return this.$store.state.searchStore.eventEndDate
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'eventEndDate',
          value: newValue,
        })
      },
    },
    spmStartDate: {
      get: function () {
        return this.$store.state.searchStore.spmStartDate
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'spmStartDate',
          value: newValue,
        })
      },
    },
    spmEndDate: {
      get: function () {
        return this.$store.state.searchStore.spmEndDate
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'spmEndDate',
          value: newValue,
        })
      },
    },
    choosePraqualifikasiK3l: {
      get: function () {
        return this.$store.state.searchStore.choosePraqualifikasiK3l
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePraqualifikasiK3l',
          value: newValue,
        })
      },
    },
    choosePraqualifikasiKplh: {
      get: function () {
        return this.$store.state.searchStore.choosePraqualifikasiKplh
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePraqualifikasiKplh',
          value: newValue,
        })
      },
    },
  },

  methods: {
    kbliShowBtn() {
      this.kbliShow = !this.kbliShow
    },
    iujpShowBtn() {
      this.iujpShow = !this.iujpShow
    },
    iujptlShowBtn() {
      this.iujptlShow = !this.iujptlShow
    },
    sbujkShowBtn() {
      this.sbujkShow = !this.sbujkShow
    },
    inubbmShowBtn() {
      this.inubbmShow = !this.inubbmShow
    },
    siupalShowBtn() {
      this.siupalShow = !this.siupalShow
    },
    showKbliEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addKbli',
        status: true,
      })
    },
    showIujpEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addIujp',
        status: true,
      })
    },
    showSbujkEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addSbujk',
        status: true,
      })
    },
    showIujptlEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addIujptl',
        status: true,
      })
    },
    showInuBbmEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addInuBbm',
        status: true,
      })
    },
    showSiupalEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addSiupal',
        status: true,
      })
    },
    async getCriteria() {
      try {
        const urlK3l = `${api}/api/v1/k3l-categories?page=1&limit=50`
        const urlKplh = `${api}/api/v1/kplh-categories?page=1&limit=50`

        const { data: k3l } = await axios({
          method: 'GET',
          url: urlK3l,
        })

        const { data: kplh } = await axios({
          method: 'GET',
          url: urlKplh,
        })

        this.k3lCategories = k3l.data
        this.kplhCategories = kplh.data
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async getKbli() {
      this.kbliList = await this.$getKbli()
    },
    async getCountry() {
      const url = `${api}/api/v1/negara?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.countries = data.data
      } catch (error) { }
    },
    async getProvince() {
      const url = `${api}/api/v1/provinsi?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.provinces = data.data
      } catch (error) { }
    },
    async getCity() {
      if (!this.choosedProvince) return;
      const url = `${api}/api/v1/kota?page=1&limit=1000&provinsi=${this.choosedProvince.id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        this.cities = data.data
      } catch (error) { }
    },
    async getDistric() {
      const url = `${api}/api/v1/kecamatan?page=1&limit=10000&kota=${this.choosedCity.id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.districs = data.data
      } catch (error) { }
    },
    async getVillage() {
      const url = `${api}/api/v1/kelurahan?page=1&limit=1000&kecamatan=${this.choosedDistric.id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.villages = data.data
      } catch (error) { }
    },
    closeModal() {
      const self = this
      this.$store.commit('searchStore/RESET_FILTER')
      this.$store.commit('level1/RESET_QUERY')
      self.$store.commit('searchStore/SHOW_MODAL', false)
    },
    async resetFilter() {
      await this.$store.commit('searchStore/RESET_FILTER')
      await this.$store.commit('level1/RESET_QUERY')
    },
    async runSearch() {
      let query = {
        vendorName:
          this.vendorName && this.vendorName !== ''
            ? `&search=${this.vendorName}`
            : '',
        status: this.chooseStatus ? `&status=${this.chooseStatus}` : '',
        negara: this.choosedCountry
          ? `&negara_id=${this.choosedCountry.id}`
          : '',
        prov: this.choosedProvince
          ? `&provinsi_id=${this.choosedProvince.id}`
          : '',
        kota: this.choosedCity ? `&kota_id=${this.choosedCity.id}` : '',
        kec: this.choosedDistric
          ? `&kecamatan_id=${this.choosedDistric.id}`
          : '',
        kel: this.choosedVillage
          ? `&kelurahan_id=${this.choosedVillage.id}`
          : '',
        tambang: this.chooseMine ? `&pertambangan_inti=1` : '&pertambangan_inti=0',
        sio: this.chooseSio ? `&sio=${this.chooseSio}` : '',
        k3l: this.choosePraqualifikasiK3l ? '&k3l=1' : '',
        kplh: this.choosePraqualifikasiKplh ? '&kplh=1' : '',
        poStart: this.poStartDate ? `&po_start_date=${this.poStartDate}` : '',
        poEnd: this.poEndDate ? `&po_end_date=${this.poEndDate}` : '',
        eventStart: this.eventStartDate
          ? `&event_start_date=${this.eventStartDate}`
          : '',
        eventEnd: this.eventEndDate
          ? `&event_end_date=${this.eventEndDate}`
          : '',
        spmStart: this.spmStartDate
          ? `&spm_start_date=${this.spmStartDate}`
          : '',
        spmEnd: this.spmEndDate ? `&spm_end_date=${this.spmEndDate}` : '',
        sioStart:
          this.chooseSio == 1 && this.sioStartDate
            ? `&sio_start_date=${this.sioStartDate}`
            : '',
        sioEnd:
          this.chooseSio == 1 && this.sioEndDate
            ? `&sio_end_date=${this.sioEndDate}`
            : '',
        k3lStart:
          this.choosePraqualifikasiK3l && this.k3lStartDate
            ? `&k3l_end_date=${this.k3lStartDate}`
            : '',
        k3lEnd:
          this.choosePraqualifikasiK3l && this.k3lEndDate
            ? `&k3l_end_date=${this.k3lEndDate}`
            : '',
        kplhStart:
          this.choosePraqualifikasiKplh && this.kplhStartDate
            ? `&kplh_end_date=${this.kplhStartDate}`
            : '',
        kplhEnd:
          this.choosePraqualifikasiKplh && this.kplhEndDate
            ? `&kplh_end_date=${this.kplhEndDate}`
            : '',
        gradeStart: this.spmScoreStart
          ? `&grade_start=${this.spmScoreStart}`
          : '',
        gradeEnd: this.spmScoreEnd ? `&grade_end=${this.spmScoreEnd}` : '',
        csiStart: this.poScoreStart ? `&csi_start=${this.poScoreStart}` : '',
        csiEnd: this.poScoreEnd ? `&csi_end=${this.poScoreEnd}` : '',
        k3lScore:
          this.choosePraqualifikasiK3l && this.chooseK3lScore.length > 0
            ? this.paramsFormatter('k3l_score', this.chooseK3lScore)
            : '',
        kplhScore:
          this.choosePraqualifikasiKplh && this.chooseKplhScore.length > 0
            ? this.paramsFormatter('kplh_score', this.chooseKplhScore)
            : '',
        kbliSub:
          this.choosedKbli && this.choosedKbli.length > 0
            ? this.paramsFormatter(
              'kbli_sub',
              this.choosedKbli.map(item => {
                return item.id
              })
            )
            : '',
        iujp:
          this.choosedIujp && this.choosedIujp.length > 0
            ? this.paramsFormatter(
              'iujp',
              this.choosedIujp.map(item => {
                return item.id
              })
            )
            : '',
        iujptl:
          this.choosedIujptl && this.choosedIujptl.length > 0
            ? this.paramsFormatter(
              'iujptl',
              this.choosedIujptl.map(item => {
                return item.id
              })
            )
            : '',
        sbujk:
          this.choosedSbujk && this.choosedSbujk.length > 0
            ? this.paramsFormatter(
              'sbujk',
              this.choosedSbujk.map(item => {
                return item.id
              })
            )
            : '',
        inubbm:
          this.choosedInuBbm && this.choosedInuBbm.length > 0
            ? this.paramsFormatter(
              'inubbm',
              this.choosedInuBbm.map(item => {
                return item.id
              })
            )
            : '',
        siupal:
          this.choosedSiupal && this.choosedSiupal.length > 0
            ? this.paramsFormatter(
              'siupal',
              this.choosedSiupal.map(item => {
                return item.id
              })
            )
            : '',
      }

      if (this.choosedKbli && this.choosedKbli.length > 0) {
        await this.$store.commit('level1/SET_STATUS_CATEGORY')
      }

      await this.$store.commit('modalStore/SET_MODAL_LEVEL1', false)
      await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      await this.$store.commit('searchStore/SHOW_MODAL', false)

      if (this.$route.path !== '/level1') {
        await this.$router.push('level1')
      }
    },
  },
}
</script>
<style></style>
